<template>
  <div v-loading="!loaded" class="timeline-dark">
    <div v-if="dayView=='vertical_timeline'">

      <q-timeline :layout="'loose'" color="secondary" dark v-if="dayEvents">
        <template v-for="(day,idx) in dayEvents">
          <div :key="idx">
            <q-timeline-entry heading>
              {{ formatUnxTime(day.time / 1000, false, true) }}
              <br/>
              <!-- ({{$q.screen.lt.sm ? 'Dense' : ($q.screen.lt.md ? 'Comfortable' : 'Loose')}} layout) -->
            </q-timeline-entry>

            <q-timeline-entry
                v-for="(event,stimestmp) in day.data"
                :subtitle="formatUnxTime(event.time,true)"
                :title="event.vehicle_name"
                :side="event.direction=='in'?'left':'right'"
                :color="event.direction=='in'?'green':'orange'"
                :icon="event.direction=='in'?'local_parking':'directions_car'"
                :key="stimestmp"
                @click="handleEventCLick(event)"
            >
              <div v-html="timeAssetRenderer(event)"></div>
            </q-timeline-entry>
          </div>
        </template>
      </q-timeline>
    </div>
    <div v-else-if="dayView=='table'">
      <s-table v-if="dayView=='table'"
               :topOffset="75"
               heightWish="90%"
               default-sort="bk_days_to_action"
               :row-class-factory="decorateRow"
               :pagging="41"
               @cell-clicked="handleEventCLick"
               vxmodel="serverData"
               :modx-processor="modxProcessor"
               :col-definitions="colDefinitions" :r-query="{...timeQuery,limit:null}">

      </s-table>
    </div>
    <div style="min-height: 50vh" v-else>


      <timeline
          v-if="tshow"
          ref="timeline"
          :items="items"
          :groups="groups"
          :options="options"
          :key="clock"
          @double-click="isTouchDevice()?null:handleEventCLick($event)"
          @click="isTouchDevice()?handleEventCLick($event):null"
          :events="['doubleClick','click']"
      ></timeline>
      <q-spinner-puff v-else color="deep-orange" style="margin-left: 50%;margin-top: 50%" size="5.5em"/>
    </div>
  </div>
</template>

<script>
import * as api from "~/api/resource";
import {DataSet} from "vue2vis";
import moment from "moment";


export default {
  name: "STimeline",

  props: {
    dayView: {
      type: String,
      default: 'timeline',
    },
    modxProcessor: {
      type: String,
      default: null,
    },
    onlyUsedGroups: {
      type: Boolean,
      default: false,
    },
    timeRangeProp: {
      type: String,
      default: null,
    },
    groupProp: {
      type: String,
      default: null,
    },
    superGroupProp: {
      type: String,
      default: null,
    },
    groupEndPoint: {
      type: Function,
      default: () => {
      },
    },
    groupRenderer: {
      type: Function,
      default: () => {
      },
    },
    timeAssetRenderer: {
      type: Function,
      default: () => {
      },
    },
    superGroupAggregator: {
      type: Function,
      default: () => {
      },
    },
    timeQuery: {
      type: Object,
      default: () => {
      },
    },
  },
  watch: {
    timeQuery: {
      handler: async function (newValue) {
        const stmp = JSON.stringify(newValue);
        // _log_("p1 timeQuery", stmp, this.cahcedQuery);
        if (stmp == this.cahcedQuery) return;
        this.cahcedQuery = stmp;
        // this.loaded = false;
        // _log_("p1", newValue);
        await this.loadData();
        // ++this.clock
        // this.loaded = true;
        // _log_(this.timeQuery);
      },
      deep: true,
      // immediate: true
    },
  },
  methods: {
    download() {

      let excelConf = this.colDefinitions.filter(c => c.excel).map(c => ({
        field: c.prop,
        label: c.label,
        ...c.excel
      }));
      excelConf = JSON.stringify(excelConf)
      api.ajax_download(this.modxProcessor, {
        excelConf,
        ...this.timeQuery,
        limit: 0,
      });

    },
    decorateRow(r) {

      const ds = parseInt(Math.round(r.row.bk_days_to_action * 1))
      _log_("decorateRow", ds, r);
      if (ds == 0) return 'today'
      if (ds == 1) return 'tomorrow'
    },
    // zoom() {
    //   this.$refs.timeline.setWindow("2019-1-1", "2018-1-1");
    // },
    handleEventCLick(e) {

      if (e.what == "background") {
        const bk = this.groups.get(e.group);
        this.$emit("timeline-clicked", {group: bk, time: e.time});
      } else if (e.item) {
        this.$message("Loading booking...");
        const bk = this.items.get(e.item);
        _log_("oooo", bk);
        this.$emit("event-clicked", bk);
      } else this.$emit("event-clicked", e.row || e);
      //   this.routeGo({
      //     name: "EditBooking",
      //     query: { bkid: bk.idBooking }
      //   });
      // }
    },

    async renderGroups(timeAssets) {
      var vm = this;
      // if (vm.groups) return;
      const data = await this.groupEndPoint(this.timeQuery);
      // _log_("goooo.renderGroups..", data);
      if (!data) {
        console.error("Failed to lad groups for ", this.timeQuery);
        return;
      }
      vm.groups = new DataSet();
      for (const key in data) {
        let groupAsset = data[key];
        if (this.onlyUsedGroups) {
          let qG = {};
          qG[this.groupProp] = groupAsset.id;
          if (timeAssets && timeAssets.length)
            if (!this.findInArray(timeAssets, qG)) continue;
        }
        // groupAsset.className = "roomGroup";
        let duperGroup = null;
        groupAsset.content = this.groupRenderer(groupAsset);

        if (this.superGroupProp) {
          let superGroupKey = groupAsset[this.superGroupProp]
              ? groupAsset[this.superGroupProp]
              : "U/N";
          duperGroup = vm.groups.get(superGroupKey);
          if (!duperGroup) {
            duperGroup = {
              id: superGroupKey,
              content: superGroupKey,

              style: "color: white; background-color: #009587;",
              nestedGroups: [],
            };
            vm.groups.add(duperGroup);
          }
        }

        // groupAsset.style =
        //   "background-color:" + getPastelColors(groupAsset.type);
        // groupAsset = setTypeOrder(groupAsset);

        if (duperGroup) duperGroup.nestedGroups.push(groupAsset.id);
        if (vm.groups.get(groupAsset.id)) vm.groups.update(groupAsset);
        else vm.groups.add(groupAsset);
      }
      _log_("goooo.renderGroups..", vm.groups.get());
      return data;
    },
    renderTimeAssets(data) {
      data = data && data.results ? data.results : data;
      _log_("goooo...", data);
      const vm = this;
      // if (!vm.items)

      let dayEvents = {};
      if (!data.length) {
        const samples = vm.groups.get();
        if (!samples[0]) return;
        let sample = {start: new Date(), id: 0};
        sample[[this.groupProp]] = samples[0].id;
        vm.items.add(sample);
        return {};
      }
      let minTime = null, maxTime = null
      // return;
      for (const key in data) {
        // if (data.hasOwnProperty(key)) {
        let timeAsset = data[key];
        timeAsset.group = timeAsset[this.groupProp];

        timeAsset.content = this.timeAssetRenderer(timeAsset);
        let timeEventIn = _.clone(timeAsset),
            timeEventOut = _.clone(timeAsset);
        timeEventIn.direction = "in";
        timeEventIn.time = timeEventIn.end;
        maxTime = !maxTime || maxTime < timeEventIn.end ? timeEventIn.end : maxTime
        timeEventOut.direction = "out";
        timeEventOut.time = timeEventIn.start;
        minTime = !minTime || minTime > timeEventIn.start ? timeEventIn.start : minTime

        let inEvents = dayEvents[timeEventIn.time];
        if (!inEvents) inEvents = [];
        inEvents.push(timeEventIn);
        dayEvents[timeEventIn.time] = inEvents;
        let outEvents = dayEvents[timeEventOut.time];
        if (!outEvents) outEvents = [];
        outEvents.push(timeEventOut);
        dayEvents[timeEventOut.time] = outEvents;

        // if (!this.dayEvents[timeEventOut.time])
        //   this.dayEvents[timeEventOut.time] = [];
        // this.dayEvents[timeEventOut.time].push(timeEventOut);
        // timeAsset.id = key;
        // if (timeAsset.comments != null && timeAsset.comments != "")
        //   timeAsset.content = timeAsset.comments + "|" + timeAsset.name;
        // else timeAsset.content = timeAsset.name;t.compact = false;
        timeAsset.className = "time-asset";
        // _log_("the _focusOn../", this.timeQuery?._focusOn, timeAsset.bk_id);
        if (this.timeQuery?._focusOn == timeAsset.bk_id)
          timeAsset.className += " last-edit";
        // _log_("oee..0." + timeAsset.id, vm.items.get(timeAsset.id));
        if (vm.items.get(timeAsset.id)) vm.items.update(timeAsset);
        else vm.items.add(timeAsset);
        // }
        // _log_("oee...", vm.items.get(timeAsset.id));
      }
      //build array
      this.dayEvents = [];
      for (const key in dayEvents) {
        if (dayEvents.hasOwnProperty(key)) {
          let Telement = dayEvents[key];
          Telement.sort((a, b) => a.time - b.time);
          this.dayEvents.push({time: key, data: Telement});
        }
      }
      this.dayEvents.sort((a, b) => a.time - b.time);
      return {maxTime, minTime};
      _log_("oee...dayEvents..", maxTime, minTime, this.dayEvents);
    },
    async loadData(force) {
      _log_("oee....1.");

      this.loaded = false;
      // this.tshow = false;
      // await this.groupEndPoint()
      const {data} = await api.fetchProcessor(this.modxProcessor, {
        ...this.timeQuery,
        limit: 0,
      });

      // data = { results: [] };
      this.loaded = true;
      // if (!data || !data.results || !data.results.length) {
      //   this.loaded = true;
      //   return false;
      // }
      // _log_("oee...dayEvents.12.", data.results);
      const groupAssets = await this.renderGroups(); //data.results
      this.items = new DataSet({
        type: {start: "ISODate", end: "ISODate"},
      });
      _log_("oee...dayEvents.13.");
      const {maxTime, minTime} = this.renderTimeAssets(data);
      this.serverData = data?.results
      const reqMinDate = this.grToDate(this.timeQuery[this.timeRangeProp + "_from"])?.getTime(),
          reqMaxDate = this.grToDate(this.timeQuery[this.timeRangeProp + "_to"])?.getTime()

      this.options.min = this.options.start = reqMinDate && reqMinDate < minTime ? reqMinDate : minTime// this.grToDate(this.timeQuery[this.timeRangeProp + "_from"])
      this.options.max = this.options.end = reqMaxDate && reqMaxDate > maxTime ? reqMaxDate : maxTime// this.grToDate(this.timeQuery[this.timeRangeProp + "_to"])
      _log_("oee...dayEvents.4.", reqMinDate, moment(minTime).format('D/M'), moment(maxTime).format('D/M'));
      if (this.superGroupAggregator)
        this.items.add(this.superGroupAggregator(groupAssets, data.results));
      this.loaded = true;
      this.tshow = true;
      if (this.$refs.timeline)
        this.$nextTick(() => {
          this.$refs.timeline.setData({
            groups: this.groups,
            items: this.items
          })
          this.$refs.timeline.setOptions(this.options);
          // this.$refs.timeline.setWindow(
          //     new Date(minTime),
          //     new Date(maxTime)
          // );
          _log_("oee...dayEvents.9 redraw")
          this.$refs.timeline.redraw()
          if (force) ++this.clock
        });
      return true;
      // }
    },
  },
  data() {
    const vm = this
    return {
      clock: 1,
      serverData: [],
      colDefinitions: [
        {

          prop: "bk_days_to_action",
          width: 80,
          elIcon: "el-icon-message-solid",
          formatter(val) {
            const cval = parseInt(val), days = parseInt(Math.round(val * 1))

            return cval >= 999 ? 'too late' : (days ? (days == 1 ? 'tomorrow' : days + ' days') : 'TODAY');
          },
        },
        {
          prop: "start",
          excel: {format: 'jsunixtime:date-time'},
          width: 120,
          label: "Time Deliver",
          formatter: function (val) {
            let cls = 'default'
            // _log_('start..',moment(val).format('DD/MM/YYYY') == moment().format('DD/MM/YYYY'),moment(val).format('DD/MM/YYYY') , moment().format('DD/MM/YYYY'))
            if (moment(val).format('DD/MM/YYYY') == moment().format('DD/MM/YYYY'))
              cls = 'danger'
            return `<span class='label-${cls}'>${moment(val).format('DD/MM/YYYY HH:mm')}</span>`;
          },
        },
        {
          prop: "pupnameA", excel: true,
          width: 120,
          label: "Deliver Place",
        },
        {
          prop: "end",
          width: 120,
          label: "Time Receive",
          excel: {format: 'jsunixtime:date-time'},
          formatter: function (val) {
            let cls = 'default'
            // _log_('start..',moment(val).format('DD/MM/YYYY') == moment().format('DD/MM/YYYY'),moment(val).format('DD/MM/YYYY') , moment().format('DD/MM/YYYY'))
            if (moment(val).format('DD/MM/YYYY') == moment().format('DD/MM/YYYY'))
              cls = 'danger'
            return `<span class='label-${cls}'>${moment(val).format('DD/MM/YYYY HH:mm')}</span>`;
          },
        },
        {
          excel: true,
          prop: "pupnameZ",
          width: 120,
          label: "Receive Place",
        },
        {
          excel: true,
          prop: "vehicle_name",
          width: 150,
          label: "Veh.Name",
        },

        {
          excel: true,
          prop: "v_type",
          width: 50,
          label: "Type",
        },
        {
          excel: true,
          prop: "v_vgroup",
          width: 50,
          label: "Group",
        },


        {
          excel: {format: 'money'},
          prop: "bk_bookedPrice",
          width: 100,
          label: "Price",

          formatter: function (val, colDefs, row, vm) {
            return vm.$theMoney(val * 1);
          },
        },
        {
          excel: {format: 'money'},
          prop: "pays",
          width: 150,
          label: "Payments",
          formatter: function (val, colDefs, row, vm) {
            _log_('(val * 1 < row.bk_bookedPrice * 1', val, row.pays, val * 1 < row.bk_bookedPrice * 1)
            return '<span class="label-' + (val * 1 >= row.bk_bookedPrice * 1 ? 'primary' : 'warning') + '">' + vm.$theMoney(row.pays) + '</span>'

          },
        },
        {
          excel: {value_path: ['aboutPayment']},//no need yet
          prop: "bk_notes.aboutPayment",
          width: 150,
          label: "Payment Comments",
          sortable: false,
          formatter: function (val, colDefs, row, vm) {
            return row.bk_notes?.aboutPayment;
          },
        },
        {
          excel: true,
          prop: "bk_customer",
          width: 150,
          label: "Customer",
        },
        {
          excel: true,
          prop: "bk_reference",
          width: 150,
          label: "Phone",
        },
        {
          excel: {value_path: ['driver_email']},
          prop: "bk_notes.driver_email",
          width: 100,
          label: "Email",
          sortable: false,
          formatter: function (val, colDefs, row, vm) {
            return row.bk_notes?.driver_email;
          },
        },
        {
          excel: {value_path: ['birthDate']},
          prop: "bk_notes.birthDate",
          width: 100,
          label: "Birth Date",
          sortable: false,
          formatter: function (val, colDefs, row, vm) {
            return row.bk_notes?.birthDate;
          },
        },
        {
          excel: {value_path: ['drivingLicenseNum']},
          prop: "bk_notes.drivingLicenseNum",
          width: 100,
          label: "Driving Lic.Num.",
          sortable: false,
          formatter: function (val, colDefs, row, vm) {
            return row.bk_notes?.drivingLicenseNum;
          },
        },
        {
          excel: {value_path: ['issueDate']},
          prop: "bk_notes.issueDate",
          width: 100,
          label: "Driving Lic.Date",
          sortable: false,
          formatter: function (val, colDefs, row, vm) {
            return row.bk_notes?.issueDate;
          },
        },
        {
          excel: {value_path: ['additionalDriver']},
          prop: "bk_notes.additionalDriver",
          width: 100,
          label: "Driver B",
          sortable: false,
          formatter: function (val, colDefs, row, vm) {
            return row.bk_notes?.additionalDriver;
          },
        },

        {
          excel: true,
          prop: 'fuel_A_klmconusmed',
          label: 'KLM Delivered'
        },
        {
          excel: true,
          prop: 'fuel_A_load',
          label: 'Fuel Start Level'
        },
        {
          excel: true,
          prop: 'fuel_A_comments',
          label: 'Condition'
        },
        {
          excel: true,
          prop: 'details',
          label: 'Insurance'
        }

      ],
      cahcedQuery: null,
      loaded: false,
      groups: new DataSet(),
      // items: null,
      dayEvents: null,
      tshow: false,
      // roomGroups: [],
      items: new DataSet({
        type: {start: "ISODate", end: "ISODate"},
      }),
      options: {
        // groupHeightMode: 'fixed',
        height: window.innerHeight - 180,
        editable: false,
        stack: false,
        groupOrder(arg1, arg2) {
          const a = (arg1.vgroup + "") + (arg1.name + ""), b = (arg2.vgroup + "") + (arg2.name + "")
          // _log_('groupOrder',a,b)
          if (a?.toLowerCase() < b?.toLowerCase()) return -1;
          if (a?.toLowerCase() > b?.toLowerCase()) return 1;
          return 0;

        }
      },
    };
  },
  computed: {
    getDays() {
      return this.items ? this.items.get() : null;
    },
  },
  async mounted() {
    this.cahcedQuery = JSON.stringify(this.timeQuery)
    setTimeout(async () => {
      let rect = this.$el.getBoundingClientRect();
      this.options.height = window.innerHeight - rect.top - 5

      _log_("timeleine ", this.timeQuery);
      if (this.dayView == 'timeline') await this.loadData(true);
      else {
        this.loaded = true;
        this.tshow = true;
      }
    }, 800)

  },
};
</script>

<style>
.el-table__row.today td {
  border: 1px solid red;
}

.time-asset.last-edit {
  filter: contrast(1.1);
  background-color: white;
  box-shadow: 0px 0px 14px white;
}

.el-table__row.tomorrow td {
  border: 1px dotted #dd4e4e;
}

.timeline-dark {
  background-color: #033740;
}

.vis-label.collapsed {
  color: #e3cbaa !important;
}

.vis-label.expanded {
  color: rgb(215, 235, 215);
}
</style>